export const enum PHONE_VERIFICATION_TYPES {
  OTP = 'otp',
  PASSWORD = 'password',
}

export const NUMBER_OF_ATTEMPTS = 3;
